import axiosApiInstance from "../../../helpers/axiosConfig";

const Status = (dispatch) => {
  axiosApiInstance
    .get(process.env.REACT_APP_API_DOMAIN + "api/v1/status")
    .then(res => {
      dispatch({type: "STATUS", status: res.data});
      dispatch({type: "STATUS_UPDATED", status_updated: true});
    })
    .catch((error) => {
      console.error(error.message);
    });
};

export default Status;